import { types } from 'mobx-state-tree'

import TrafficCounty from './TrafficCounty'
import TrafficCourt from './TrafficCourt'
import TrafficRegionConfiguration from './TrafficRegionConfiguration'

const TrafficRegion = types
  .model('TrafficRegion', {
    objectId: types.maybeNull(types.identifier),
    name: types.maybeNull(types.string),
    state: types.maybeNull(types.string),
    trafficCounties: types.array(TrafficCounty),
    trafficCourts: types.array(TrafficCourt),
    image: types.maybeNull(types.string),
    order: types.optional(types.number, 0),
    configuration: types.optional(TrafficRegionConfiguration, {}),
    successRate: types.maybeNull(types.number),
    suggestedCourts: types.array(
      types.frozen({
        // name: types.string,
        // objectId: types.string,
        // county: types.string
      }),
    ),
  })
  .preProcessSnapshot((snapshot) => {
    if (!snapshot) return null
    // this function will run on a snapshot to format it before submitting it to the store.
    const parsedSnapshot = {}
    const keys = Object.keys(snapshot)
    keys.forEach((key) => {
      const input = snapshot[key]
      switch (key) {
        case 'suggestedCourts': {
          const courtsArr = [...input]
          parsedSnapshot[key] = courtsArr.sort((a, b) => {
            if (a.name < b.name) return -1
            if (a.name > b.name) return 1
            return 0
          })
          break
        }
        case 'image':
          parsedSnapshot[key] = null
          if (input && input.url) {
            // parse response
            parsedSnapshot[key] = input.url
          }
          if (input && typeof input === 'string') {
            // ssr / client reload
            parsedSnapshot[key] = input
          }
          break
        default:
          parsedSnapshot[key] = input
          break
      }
    })
    return parsedSnapshot
  })

export default TrafficRegion
